import React, { useEffect } from 'react';
import { BwjBillboard } from '../../framework/components/bwj-billboard';
import { useNavigator } from '../../framework/services/navigation';
import { CurrentUserService } from '../../app/current-user';
import { AppRoutes } from '../app-routes';

export const SignedOutPage: React.FunctionComponent = () => {
  const nav = useNavigator();

  useEffect(() => {
    if(CurrentUserService.isSignedIn()) {
      nav.goTo(AppRoutes.home.url());
    }
  }, [nav])


  return (
    <BwjBillboard
      icon={'jw:person-circle'}
      message={'You are signed out - use the link provided by the department overseer to sign back in'}
    />
  );
};
